import { isSuperAdminUser } from './googleAuth';

const CHARTS_PLAN_SLUGS = ['profesional', 'empresarial', 'enterprise'];

export function planSlugHasDashboardCharts(slug) {
  return CHARTS_PLAN_SLUGS.includes(String(slug || '').toLowerCase());
}

/**
 * Gráficos del inicio: tier Prof+ o flag explícito en el plan.
 * Usa user.currentPlan si userPlan del hook aún no cargó (navegación entre rutas).
 */
export function resolveCanViewCharts(user, userPlan) {
  if (!user) return false;
  if (user.role === 'admin' && user.isSuperAdmin === true) return true;

  const plan = userPlan || user.currentPlan;
  if (!plan) return false;

  const slug = plan.slug || user.currentPlan?.slug;
  if (planSlugHasDashboardCharts(slug)) return true;

  return Boolean(plan.dashboardPermissions?.canViewCharts);
}

/**
 * Ingresos por país describe el negocio del tenant (clientes en el exterior).
 * No aplica al operador de la plataforma (superadmin ve datos mezclados o el libro O1).
 */
export function shouldShowIngresosPorPais(user) {
  return !isSuperAdminUser(user);
}
